<template>
    <div>
        <span><a :href="url">{{title}}</a>.&nbsp;</span>
        <span>{{publication}}.&nbsp;</span>
        <span v-if="author">{{author}}.&nbsp;</span>
        <span>{{date}}.</span>
    </div>
</template>

<script>
export default {
    props: [
        "url",
        "title",
        "publication",
        "author",
        "date"
    ]
}
</script>